import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Link,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import carHero from '../images/image_0.jpeg'; // 1. Mobil (Hero Shot)
import velgCloseUp from '../images/image_4.jpeg'; // 2. Velg 18 Inci
import interiorDashboard from '../images/image_5.jpeg'; // 3. Interior Dashboard
import headUnitScreen from '../images/image_6.jpeg'; // 4. Layar 15.6 Inci
import jokDoorInterior from '../images/image_7.jpeg';
import bagasiTransmisi from '../images/image_8.jpeg';
import PageSeo, {
  articleJsonLd,
  breadcrumbJsonLd,
  keywordSets,
  productJsonLd,
} from '../PageSeo';

function Atto3AdvancedPlusDetail() {
  const priceStd = 390000000;
  const pricePlus = 415000000;
  const formattedPrice = 'Rp 415.000.000';

  const pageTitle = `BYD Atto 3 2026 | Harga ${formattedPrice} dan Spesifikasi`;
  const pageDescription = `Cek BYD Atto 3 2026 di BYD BSD Serpong. Harga Advanced Plus ${formattedPrice}, fitur ADAS, panoramic sunroof, Blade Battery, promo, dan test drive.`;

  return (
    <Box
      sx={{ padding: { xs: 2, sm: 4 }, maxWidth: '1200px', margin: '0 auto' }}
    >
      <PageSeo
        title={pageTitle}
        description={pageDescription}
        keywords={[
          ...keywordSets.localDealer,
          'BYD Atto 3 2026',
          'harga BYD Atto 3',
          'BYD Atto 3 Advanced Plus',
          'SUV listrik BYD BSD',
          'test drive BYD Atto 3',
        ]}
        path='/blog/atto-3-suv-listrik-stylish'
        image={carHero}
        type='article'
        jsonLd={[
          productJsonLd({
            name: 'BYD Atto 3 Advanced Plus',
            description: pageDescription,
            image: carHero,
            path: '/blog/atto-3-suv-listrik-stylish',
            lowPrice: priceStd,
            highPrice: pricePlus,
            offerCount: 2,
          }),
          articleJsonLd({
            title: pageTitle,
            description: pageDescription,
            image: carHero,
            path: '/blog/atto-3-suv-listrik-stylish',
          }),
          breadcrumbJsonLd([
            { name: 'Beranda', path: '/' },
            { name: 'Blog', path: '/blog' },
            { name: 'BYD Atto 3', path: '/blog/atto-3-suv-listrik-stylish' },
          ]),
        ]}
      />

      <Box sx={{ mt: 10 }}>
        {/* H1: Judul Utama SEO */}
        <Typography
          variant='h3'
          component='h1'
          fontWeight='bold'
          gutterBottom
          sx={{ fontSize: { xs: '2rem', md: '3rem' } }}
        >
          BYD Atto 3 Advanced Plus 2026: Varian Paling Value for Money
        </Typography>

        {/* 1. Mobil (Hero Shot) */}
        <Box
          component='img'
          src={carHero}
          alt='BYD Atto 3 Advanced Plus Hitam varian terbaru 2026 tampak depan di BSD Serpong'
          sx={{
            width: '100%',
            height: 'auto',
            borderRadius: 2,
            mb: 4,
            boxShadow: 3,
          }}
        />

        <Typography
          variant='body1'
          paragraph
          sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}
        >
          Sejak ajang IIMS 2026 lalu, <strong>BYD Atto 3 Advanced Plus</strong>{' '}
          hadir sebagai pilihan cerdas di antara tipe Advanced STD dan Superior.
          Dengan harga <strong>{formattedPrice}</strong>, varian ini menawarkan
          fitur premium yang sangat lengkap, menjadikannya mobil listrik paling{' '}
          <em>value for money</em> tahun ini. Selain fitur canggih, Anda
          mendapatkan keuntungan <strong>Bebas Ganjil Genap</strong> di Jakarta
          serta biaya <strong>Pajak Kendaraan Listrik Murah</strong> yang jauh
          lebih hemat.
        </Typography>

        {/* Tabel Perbandingan Varian (Data dari Gambar) */}
        <Typography
          variant='h4'
          component='h2'
          fontWeight='bold'
          sx={{ mt: 5, mb: 3 }}
        >
          Perbandingan Varian BYD Atto 3 (Harga OTR 2026)
        </Typography>

        <TableContainer component={Paper} elevation={3} sx={{ mb: 4 }}>
          <Table>
            <TableHead sx={{ backgroundColor: '#1976d2' }}>
              <TableRow>
                <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>
                  Fitur
                </TableCell>
                <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>
                  Advanced STD
                </TableCell>
                <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>
                  Advanced Plus
                </TableCell>
                <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>
                  Superior
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>
                  <strong>Harga</strong>
                </TableCell>
                <TableCell>
                  <strong>Rp 390 Juta</strong>
                </TableCell>
                <TableCell>
                  <strong>Rp 415 Juta</strong>
                </TableCell>
                <TableCell>
                  <strong>Rp 520 Juta</strong>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Jarak Tempuh (NEDC)</TableCell>
                <TableCell>410 km</TableCell>
                <TableCell>410 km</TableCell>
                <TableCell>490 km</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Pelek (Wheel)</TableCell>
                <TableCell>17 Inci</TableCell>
                <TableCell>18 Inci</TableCell>
                <TableCell>18 Inci</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Head Unit</TableCell>
                <TableCell>12.8 Inci</TableCell>
                <TableCell>15.6 Inci</TableCell>
                <TableCell>15.6 Inci</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>ADAS & Sunroof</TableCell>
                <TableCell>❌</TableCell>
                <TableCell>✅</TableCell>
                <TableCell>✅</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Power Tailgate</TableCell>
                <TableCell>❌</TableCell>
                <TableCell>✅</TableCell>
                <TableCell>✅</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        {/* 2. Velg */}
        <Grid container spacing={4} alignItems='center' sx={{ mb: 6 }}>
          <Grid item xs={12} md={6}>
            <Box
              component='img'
              src={velgCloseUp}
              alt='Pelek 18 inci terbaru pada BYD Atto 3 Advanced Plus'
              sx={{
                width: '100%',
                height: 'auto',
                borderRadius: 2,
                boxShadow: 2,
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography
              variant='h5'
              component='h3'
              fontWeight='bold'
              gutterBottom
            >
              Upgrade Pelek 18 Inci yang Sporty
            </Typography>
            <Typography variant='body1'>
              Berbeda dengan varian STD, tipe <strong>Advanced Plus</strong>{' '}
              sudah dilengkapi dengan pelek berukuran 18 inci. Ukuran ini
              memberikan stabilitas berkendara yang lebih baik serta tampilan
              yang jauh lebih gagah dan proporsional untuk sebuah SUV listrik
              modern.
            </Typography>
          </Grid>
        </Grid>

        {/* 3. Interior Dashboard */}
        <Typography
          variant='h4'
          component='h2'
          fontWeight='bold'
          sx={{ mt: 5, mb: 3 }}
        >
          Interior Futuristik dengan Teknologi Blade Battery
        </Typography>
        <Box
          component='img'
          src={interiorDashboard}
          alt='Interior mewah BYD Atto 3 Advanced Plus dengan desain dashboard futuristik'
          sx={{
            width: '100%',
            height: 'auto',
            borderRadius: 2,
            mb: 4,
            boxShadow: 2,
          }}
        />
        <Typography variant='body1' paragraph>
          Ditenagai oleh <strong>BYD Blade Battery</strong> berkapasitas 49,92
          kWh, Atto 3 Advanced Plus mampu menghasilkan torsi instan 310 Nm. Di
          dalam kabin, Anda akan disambut dengan desain interior yang
          terinspirasi dari alat musik dan gym, menciptakan suasana yang unik
          dan berbeda dari mobil listrik lainnya.
        </Typography>

        {/* 4. Layar Head Unit */}
        <Grid
          container
          spacing={4}
          alignItems='center'
          sx={{ mb: 6, flexDirection: { xs: 'column-reverse', md: 'row' } }}
        >
          <Grid item xs={12} md={6}>
            <Typography
              variant='h5'
              component='h3'
              fontWeight='bold'
              gutterBottom
            >
              Layar Masif 15.6 Inci Rotatable
            </Typography>
            <Typography variant='body1'>
              Salah satu keunggulan utama tipe Advanced Plus adalah hadirnya
              layar head unit berukuran 15.6 inci (sama dengan tipe Superior).
              Layar ini dapat berputar secara elektrik untuk navigasi yang lebih
              maksimal, mendukung gaya hidup digital Anda di perjalanan.
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              component='img'
              src={headUnitScreen}
              alt='Layar interaktif 15.6 inci BYD Atto 3 Advanced Plus yang bisa berputar'
              sx={{
                width: '100%',
                height: 'auto',
                borderRadius: 2,
                boxShadow: 2,
              }}
            />
          </Grid>
        </Grid>

        {/* 5. Jok & Pintu */}
        <Box
          component='img'
          src={jokDoorInterior}
          alt='Jok ergonomis dan panoramic sunroof mewah pada Atto 3 Advanced Plus'
          sx={{
            width: '100%',
            height: 'auto',
            borderRadius: 2,
            mb: 4,
            boxShadow: 2,
          }}
        />
        <Typography variant='body1' paragraph>
          Kenyamanan maksimal didukung oleh jok ergonomis dan hadirnya{' '}
          <strong>Panoramic Sunroof</strong> yang memberikan kesan luas pada
          kabin. Varian ini benar-benar memberikan kemewahan tipe tertinggi
          dengan harga yang jauh lebih kompetitif.
        </Typography>

        {/* 6. Bagasi & Transmisi */}
        <Grid container spacing={4} alignItems='center' sx={{ mb: 6 }}>
          <Grid item xs={12} md={6}>
            <Box
              component='img'
              src={bagasiTransmisi}
              alt='Fitur Power Tailgate otomatis dan tuas transmisi futuristik BYD Atto 3'
              sx={{
                width: '100%',
                height: 'auto',
                borderRadius: 2,
                boxShadow: 2,
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography
              variant='h5'
              component='h3'
              fontWeight='bold'
              gutterBottom
            >
              Kemudahan Power Tailgate Otomatis
            </Typography>
            <Typography variant='body1'>
              Membawa barang belanjaan jadi lebih praktis berkat fitur{' '}
              <strong>Power Tailgate</strong>. Cukup tekan tombol, dan pintu
              bagasi akan terbuka otomatis. Fitur ini sebelumnya hanya ada di
              tipe Superior, namun kini bisa Anda nikmati di tipe Advanced Plus.
            </Typography>
          </Grid>
        </Grid>

        {/* Section LSI: Charging Station BSD */}
        <Typography
          variant='h5'
          component='h3'
          fontWeight='bold'
          sx={{ mt: 5, mb: 2 }}
        >
          Dukungan Charging Station BSD Serpong
        </Typography>
        <Typography variant='body1' paragraph>
          Sebagai pengguna mobil listrik di Tangerang Selatan, Anda akan
          dimudahkan dengan banyaknya titik{' '}
          <strong>Charging Station BSD</strong>. Dengan jarak tempuh 410 km
          (NEDC), BYD Atto 3 Advanced Plus sangat ideal untuk mobilitas harian
          tanpa perlu sering mengisi daya.
        </Typography>

        {/* Internal Linking */}
        <Paper
          variant='outlined'
          sx={{ p: 3, my: 5, backgroundColor: '#f9f9f9' }}
        >
          <Typography variant='h6' fontWeight='bold' gutterBottom>
            Cek Juga Produk BYD Lainnya:
          </Typography>
          <Typography variant='body2' sx={{ lineHeight: 2 }}>
            • MPV Listrik Keluarga:{' '}
            <Link component={RouterLink} to='/blog/byd-m6-mpv-listrik-keluarga'>
              Spesifikasi Lengkap BYD M6
            </Link>
            .<br />• SUV Premium:{' '}
            <Link
              component={RouterLink}
              to='/blog/sealion-7-suv-listrik-sporty'
            >
              Harga BYD Sealion 7 Performance AWD
            </Link>
            .<br />• Daftar Harga Terbaru:{' '}
            <Link component={RouterLink} to='/pricing'>
              Price List BYD 2026
            </Link>
            .
          </Typography>
        </Paper>

        {/* CTA */}
        <Box
          sx={{
            textAlign: 'center',
            py: 5,
            backgroundColor: '#f0f4f8',
            borderRadius: 2,
          }}
        >
          <Typography
            variant='h4'
            component='h2'
            fontWeight='bold'
            color='primary'
            gutterBottom
          >
            Test Drive Atto 3 Advanced Plus Sekarang!
          </Typography>
          <Typography variant='body1' sx={{ mb: 4 }}>
            Dapatkan promo menarik dan konsultasi Pajak Murah mobil listrik
            bersama Junius di BYD BSD Serpong.
          </Typography>
          <Button
            variant='contained'
            size='large'
            href='https://wa.me/6281286864825'
            target='_blank'
            sx={{
              fontWeight: 'bold',
              px: 6,
              py: 1.5,
              borderRadius: '25px',
              fontSize: '1.1rem',
            }}
          >
            Hubungi Junius (WhatsApp)
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default Atto3AdvancedPlusDetail;
